// extracted by mini-css-extract-plugin
export default {"note":"chatNote_note__JHBe8","loader":"chatNote_loader__U5AN3","l1":"chatNote_l1__39U3H"};